module.exports = __webpack_public_path__ + "static/media/23.2cdcc8d8.jpg";